/* eslint-disable no-console */
import { Modal, Box, Typography, Grid2, TextField, Button } from '@mui/material';
import React, { useState } from 'react';
import styles from './Modals.module.css';
import { createTest, TestRequest } from './helper.stim';
import { useAlert } from '../../components/alertProvider';
import { formatDateToLocalYYYYMMDD } from '../../services/time';
import {ReactComponent as WarningCircle} from '../../assets/SVG/Warning.svg';
interface HormoneValueModalProps {
    hormonesModalOpen: boolean,
    handleHormonesModalClose: () => void,
    hormoneId?: number,
    patientId: number,
    date?: Date,
    cycle: number,
    id?: number,
    value?: string,
    selected_stim: number
}

const HormoneValueModal: React.FC<HormoneValueModalProps> = ({hormonesModalOpen, handleHormonesModalClose, patientId, date, hormoneId, value, id, selected_stim}) => {
  const {addAlert} = useAlert();
  const updatedValue = value? value === '+'? '': value: '';
  const [hormonesFormData, setHormonesFormData] = useState({
    hormoneValue: updatedValue || '',
  });
 
  const handleHormonesChange = (
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    
    const { name, value } = event.target;
    setHormonesFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleHormonesSubmit = () => {
    if (hormoneId && date) {
      
      const body: TestRequest = {
        patient: patientId,
        laboratory_test: hormoneId,
        results: parseInt(hormonesFormData.hormoneValue),
        date: formatDateToLocalYYYYMMDD(date),
        stim_chart: selected_stim
      };
      createTest(body, id).catch(() => addAlert('Failed to create Hormone test', 'error'));
    }
    handleHormonesModalClose();
  };
      
  return (
    <Modal open={hormonesModalOpen} onClose={handleHormonesModalClose} >
      <Box className={`${styles.modal} ${styles.modalSmall}`} p={1}>
        {id && <Box className={styles.modalHeader}>
          <Typography variant="h3" gutterBottom>
            Add Result
          </Typography>
        </Box>}
        <Grid2 container spacing={2} className={styles.modalBody} justifyContent={id ? 'flex-start': 'center'}>          
          {id ? 
            <Grid2 size={{xs:12, md:6 }}>
              <TextField
                fullWidth
                label={<>
                  Hormone Value <span style={{ color: 'red' }}> * </span>
                </>}
                name="hormoneValue"
                placeholder="Hormone Value"
                value={hormonesFormData.hormoneValue}
                onChange={handleHormonesChange}
                margin="normal"
                slotProps={{inputLabel:{shrink: true}}}
              />
            </Grid2> : 
            <Box display={'flex'} flexDirection={'column'} alignItems={'center'} justifyContent={'center'} mb={2}>
              <WarningCircle style={{width: '3rem', height: '3rem'}}/>
              <Typography id="modal-hormones-title" variant="h5" component="p" color='primary.main' fontWeight={500} mt={3} mb={1}>
                Hormones
              </Typography>
              <Typography>Are you sure you want to schedule a Hormon Test?</Typography>
            </Box>
          }          
        </Grid2>
        <Box className={styles.primary}>
          <Button fullWidth variant="outlined" onClick={handleHormonesModalClose} className={styles.modalCancelBtn}>
            {id ? 'Cancel': 'No'}
          </Button>
          <Button fullWidth variant="contained" onClick={handleHormonesSubmit} className={styles.modalSaveBtn}>
            {id ? 'Update': 'Yes'}
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};

export default HormoneValueModal;